import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Nav from "../Components/Nav";
import { db, auth } from "../config";
import { doc, setDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { QRCodeCanvas } from "qrcode.react";

const walletAddresses = {
  BITCOIN: "bc1qzu3dysxcuflznvsttx0lnwn4gp0rvxe4l8fagt",
  ETHEREUM: "0x34C829F70412DD6A1A1Dc502473f24E67c7cB267",
  USDT: "TLsGKkZiUJmt9X7wz3w7DvUX1DJBNgjFeu", // TRC20
  USDT_ERC20: "0x34C829F70412DD6A1A1Dc502473f24E67c7cB267", // ERC20
  RIPPLE: "rNCDiF8LdAKpZogj1kkQGRdrEA3fCxtzLs"
};

function Deposit() {
  const [selectedMethod, setSelectedMethod] = useState("");
  const [amount, setAmount] = useState("");
  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
        setUserEmail(user.email);
      } else {
        setUserId(null);
        setUserEmail(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId || !selectedMethod || !amount) return;

    const depositRef = doc(db, "deposits", `${userId}_${Date.now()}`);
    await setDoc(depositRef, {
      userId,
      userEmail,
      method: selectedMethod,
      amount: parseFloat(amount),
      timestamp: new Date().toISOString(),
      status: "pending",
    });

    const modal = new window.bootstrap.Modal(
      document.getElementById("depositModal")
    );
    modal.show();
  };

  const copyToClipboard = () => {
    const address = walletAddresses[selectedMethod];
    if (address) {
      navigator.clipboard.writeText(address);
      alert("Wallet address copied!");
    }
  };

  return (
    <div>
          <Helmet>
        <script src="forthfunded/popper.min.js" />
        <script src="forthfunded/bootstrap.bundle.min.js" />
        <script src="forthfunded/defaultmenu.min.js" />
        <script src="forthfunded/waves.min.js" />
        <script src="forthfunded/sticky.js" />
        <script src="forthfunded/simplebar.min.js" />
        <script src="forthfunded/simplebar.js" />
        <script src="forthfunded/pickr.es5.min.js" />
        <script src="forthfunded/apexcharts.min.js" />
        <script src="forthfunded/crypto-dashboard.js" />
        <script src="forthfunded/custom-switcher.min.js" />
        <script src="forthfunded/custom.js" />
          </Helmet>
      <div className="page">
        <Header />
        <Nav />

        <div className="main-content app-content">
          <div className="container-fluid">
            <div className="row mb-5">
              <div className="col-xl-12 text-center">
                <h5 className="fw-semibold">Fund your Account</h5>
                <p className="text-muted col-lg-6 offset-lg-3">
                  Select any crypto asset and make deposit...
                </p>
                <div className="pb-4">
                  <img src="../assets/images/btc.png" width={50} alt="" />
                  <img src="../assets/images/usdt.png" width={50} alt="" />
                  <img src="../assets/images/eth.png" width={50} alt="" />
                </div>
              </div>

              <div className="col-xl-6 offset-xl-3">
                <div className="card custom-card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="input-group mb-3">
                        <select
                          className="form-control"
                          required
                          value={selectedMethod}
                          onChange={(e) => setSelectedMethod(e.target.value)}
                        >
                          <option value="">-- Payment method --</option>
                          <option value="BITCOIN">BITCOIN - BTC</option>
                          <option value="ETHEREUM">ETHEREUM - ETH</option>
                          <option value="USDT">USDT - TRC20</option>
                          <option value="USDT_ERC20">USDT - ERC20</option>
                          <option value="RIPPLE">RIPPLE</option>
                        </select>
                      </div>

                      <div className="input-group mb-3">
                        <input
                          type="number"
                          name="amount"
                          placeholder="Amount"
                          className="form-control"
                          required
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                      </div>

                      <div className="d-grid mt-4">
                        <button className="btn btn-primary" type="submit">
                          Fund Account
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Deposit Modal */}
        <div
          className="modal fade"
          id="depositModal"
          tabIndex="-1"
          aria-labelledby="depositModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="depositModalLabel">
                  Deposit Info
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  <strong>Wallet:</strong> {selectedMethod}
                </p>
                <p>
                  <strong>Amount:</strong>€{amount}
                </p>
                <p>
                  <strong>Send to:</strong>
                  <br />
                  <div className="d-flex align-items-center mb-2">
                    <code className="me-2" id="walletAddressText">
                      {walletAddresses[selectedMethod]}
                    </code>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={copyToClipboard}
                    >
                      Copy
                    </button>
                  </div>
                  <div className="text-center">
                    <QRCodeCanvas
                      value={walletAddresses[selectedMethod]}
                      size={150}
                      bgColor="#ffffff"
                      fgColor="#000000"
                      level="H"
                      includeMargin={true}
                    />
                    <p className="mt-2 small text-muted">
                      Scan this QR code to pay
                    </p>
                  </div>
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Deposit;
